import { render } from "./VabeneBlogPostFormPage.vue?vue&type=template&id=12865838&ts=true"
import script from "./VabeneBlogPostFormPage.vue?vue&type=script&lang=ts"
export * from "./VabeneBlogPostFormPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__